import { render, staticRenderFns } from "./marketList.vue?vue&type=template&id=2d93040e&scoped=true&"
import script from "./marketList.vue?vue&type=script&lang=js&"
export * from "./marketList.vue?vue&type=script&lang=js&"
import style0 from "./marketList.vue?vue&type=style&index=0&id=2d93040e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d93040e",
  null
  
)

export default component.exports